
import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button, Spin, Radio } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import PartnerApi from "../../helpers/PartnerApi";
import { formatDateByLang } from "../../components/function/formatDate";
import { success, error } from "../../features/toast/toastSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// const NewLicence = () => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useDispatch();
//   const [open, setOpen] = useState(false);
//   const [step, setStep] = useState(1);
//   const [errors, setErrors] = useState({});

//   const [isCalculating, setIsCalculating] = useState(false);
//   const [calcError, setCalcError] = useState("");
//   const [calcData, setCalcData] = useState(null);
//   const [calcByModule, setCalcByModule] = useState({});

//   const [isGenerating, setIsGenerating] = useState(false);
//   const [genError, setGenError] = useState("");
//   const [generatedLicenseId, setGeneratedLicenseId] = useState(null);

//   const [packOptions, setPackOptions] = useState([]);
//   const [partnerOptions, setPartnerOptions] = useState([]);
//   const [moduleOptions, setModuleOptions] = useState([]);

//   const [isLoadingPacks, setLoadingPacks] = useState(false);
//   const [isLoadingPartners, setLoadingPartners] = useState(false);
//   const [isLoadingModules, setLoadingModules] = useState(false);

//   const [countryOptions, setCountryOptions] = useState([]);

//   const primaryBtnStyle = {
//     backgroundColor: "#2563eb",
//     borderColor: "#2563eb",
//     color: "#fff",
//     boxShadow: "none",
//   };

//   const secondaryBtnStyle = {
//     backgroundColor: "#6b7280",
//     borderColor: "#6b7280",
//     color: "#fff",
//     boxShadow: "none",
//   };

//   const baseField = `
//     h-9 px-3 border rounded-md w-full
//     transition-colors
//     bg-white text-gray-900
//     border-gray-300
//     focus:outline-none focus:ring-1 focus:ring-blue-500
//   `;

//   const selectCls = baseField;
//   const selectErrCls = `${baseField} !border-red-500`;
//   const inlineSelectCls = baseField;
//   const inputCls = baseField;

//   const textareaCls = `
//     px-3 py-2 border rounded-md w-full
//     transition-colors
//     bg-white text-gray-900
//     border-gray-300
//     focus:outline-none focus:ring-1 focus:ring-blue-500
//     min-h-[90px]
//   `;

//   const readonlyCls = `
//     ${baseField}
//     bg-gray-100 text-gray-900 cursor-not-allowed
//   `;

//   const labelCls = `
//     min-w-[120px] font-medium
//     text-gray-800 dark:text-gray-100
//   `;

//   const labelWideCls = `
//     min-w-[150px] font-medium
//     text-gray-800 dark:text-gray-100
//   `;

//   const panelBoxCls = `
//     border border-gray-300 dark:border-gray-800 rounded-md p-3
//     bg-gray-50 dark:bg-gray-900 dark:text-gray-100 w-full
//     overflow-visible
//   `;

//   // ✅ SENİN YAPI: kaldırmadım
//   const languageOptions = [
//     { label: "TURKISH", value: "40" },
//     { label: "GERMAN", value: "1" },
//     { label: "ENGLISH", value: "3" },
//     { label: "FRENCH", value: "5" },
//     { label: "ARABIC", value: "19" },
//   ];

//   // ✅ UI numeric -> Backend string
//   // Bu mapping LM.name_40 hatasını engeller.
//   const apiLanguageFromUi = (uiLang) => {
//     const x = String(uiLang || "");
//     switch (x) {
//       case "40":
//         return "tr";
//       case "1":
//         return "de";
//       case "3":
//         return "en";
//       case "12":
//         return "nl";
//       case "5":
//         return "fr";
//       case "19":
//         return "ar";
//       default:
//         return "tr";
//     }
//   };

//   const initialState = useMemo(
//     () => ({
//       productCode: "",
//       partnerId: "",
//       supportArea: "",
//       supportDuration: "1year",
//       updateField1: "",
//       updateField2: "",
//       userCount: "",
//       dbCount: "",
//       selectedModules: {},
//       supportType: "",

//       // UI için numeric dili koruyoruz
//       language: "40",
//       status: 1,
//       country: "",
//       packId: "",
//       billing: {},

//       customer: {
//         ownerType: "corporate",
//         tradeName: "",
//         representativeName: "",
//         representativeTitle: "",
//         email: "",
//         tradeRegistryNo: "",
//         address: "",
//         country: "Türkiye",
//         uiLanguage: "TURKISH",
//         reference: "",
//         group: "",
//         note: "",
//         directApprove: false,
//         fullName: "",
//       },
//     }),
//     []
//   );

//   const [myFilter, setMyFilter] = useState(initialState);

//   const selectedPack = useMemo(
//     () => packOptions.find((p) => p.value === myFilter.packId),
//     [packOptions, myFilter.packId]
//   );

//   const selectedPackLabel = selectedPack?.label || "";

//   const resetAll = () => {
//     setStep(1);
//     setErrors({});

//     setMyFilter({
//       ...initialState,
//       language: initialState.language,
//     });

//     setPackOptions([]);
//     setPartnerOptions([]);
//     setModuleOptions([]);

//     setLoadingPacks(false);
//     setLoadingPartners(false);
//     setLoadingModules(false);

//     setIsCalculating(false);
//     setCalcError("");
//     setCalcData(null);
//     setCalcByModule({});

//     setIsGenerating(false);
//     setGenError("");
//     setGeneratedLicenseId(null);
//   };

//   const openModal = async () => {
//     resetAll();
//     setOpen(true);

//     // Packs
//     try {
//       setLoadingPacks(true);
//       const data = await PartnerApi.getPackList({
//         language: i18n.language || "tr",
//         status: 1,
//       });

//       const list = data?.packList || data?.data || [];
//       const options = list.map((item) => ({
//         value: item.id,
//         productCode: item.productCode,
//         productName: item.productName,
//         packName: item.packName,
//         label: `${item.productName || ""} + ${item.packName || ""}`,
//         maxUser: item.maxUser || 0,
//         maxDatabase: item.maxDatabase || 0,
//       }));

//       setPackOptions(options);
//     } catch {
//       setPackOptions([]);
//     } finally {
//       setLoadingPacks(false);
//     }

//     // Partners
//     try {
//       setLoadingPartners(true);
//       const pdata = await PartnerApi.getPartnerList({ status: 1 });
//       const plist = pdata?.partnerList || pdata?.data || [];
//       const popts = plist.filter((p) => p?.name).map((p) => ({ value: p.id, label: p.name }));
//       setPartnerOptions(popts);
//     } catch {
//       setPartnerOptions([]);
//     } finally {
//       setLoadingPartners(false);
//     }
//   };

//   const closeModal = () => setOpen(false);

//   useEffect(() => {
//     const onOpen = (e) => {
//       if (e?.detail?.modal === "new-licence") openModal();
//     };
//     window.addEventListener("AKEAD:modal-open", onOpen);

//     const legacyOpen = () => openModal();
//     window.addEventListener("AKEAD:open-new-licence", legacyOpen);

//     return () => {
//       window.removeEventListener("AKEAD:modal-open", onOpen);
//       window.removeEventListener("AKEAD:open-new-licence", legacyOpen);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Support dates auto
//   useEffect(() => {
//     if (!open) return;
//     const today = dayjs().startOf("day");
//     const n = parseInt(myFilter.supportDuration.match(/\d+/)?.[0] || "1", 10);

//     setMyFilter((p) => ({
//       ...p,
//       updateField1: today.toDate(),
//       updateField2: today.add(n, "year").add(15, "day").toDate(),
//     }));
//   }, [open, myFilter.supportDuration]);

//   // Partner/Pack change -> reset modules + calc
//   useEffect(() => {
//     if (!open) return;

//     setModuleOptions([]);
//     setMyFilter((p) => ({
//       ...p,
//       selectedModules: {},
//       billing: {},
//       userCount: "",
//       dbCount: "",
//     }));

//     setCalcError("");
//     setCalcData(null);
//     setCalcByModule({});
//     if (step > 1) setStep(1);
//   }, [open, myFilter.partnerId, myFilter.packId]);

//   // Auto fill user/db
//   useEffect(() => {
//     if (!open) return;
//     if (!selectedPack) return;

//     const userAuto =
//       selectedPack.maxUser > 0 ? (selectedPack.maxUser === 1 ? "1" : "") : "1";
//     const dbAuto =
//       selectedPack.maxDatabase > 0 ? (selectedPack.maxDatabase === 1 ? "1" : "") : "1";

//     setMyFilter((prev) => ({
//       ...prev,
//       userCount: prev.userCount || userAuto,
//       dbCount: prev.dbCount || dbAuto,
//     }));
//   }, [open, selectedPack]);

//   // Countries
//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const data = await PartnerApi.getCountryList({
//           language: apiLanguageFromUi(myFilter.language),
//           status: myFilter.status,
//           limit: 500,
//           offset: 0,
//         });

//         const list = data?.countryList || [];
//         const options = list
//           .filter((c) => c.name?.trim())
//           .sort((a, b) => a.name.localeCompare(b.name))
//           .map((c) => ({ label: c.name.trim(), value: c.id }));

//         setCountryOptions(options);

//         if (!myFilter.country && options.length > 0) {
//           setMyFilter((prev) => ({ ...prev, country: options[0].value }));
//         }
//       } catch (err) {
//         console.error("Ülke listesi alınamadı:", err);
//       }
//     };

//     fetchCountries();
//   }, [myFilter.language, myFilter.status, myFilter.country]);

//   const money = (val) => {
//     const n = Number(val || 0);
//     return Number.isFinite(n) ? n.toFixed(2) : "0.00";
//   };

//   const getTotals = () => {
//     const currency = calcData?.currencyCode || "TRY";

//     const lic = Number(calcData?.totalLicensePrice || 0);
//     const ins = Number(calcData?.totalInstallPrice || 0);
//     const trn = Number(calcData?.totalTrainingPrice || 0);
//     const upd = Number(calcData?.totalUpdatePrice || 0);

//     const totalGeneral = lic + ins + trn + upd;

//     const discountRate = Number(calcData?.discountRate || 0);
//     const totalReseller = totalGeneral * (1 - discountRate);

//     return { currency, lic, ins, trn, upd, totalGeneral, discountRate, totalReseller };
//   };

//   const onChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "packId") {
//       const valNum = value ? Number(value) : "";
//       const found = packOptions.find((p) => p.value === valNum);

//       setMyFilter((prev) => ({
//         ...prev,
//         packId: valNum,
//         productCode: found?.productCode || "",
//       }));
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//       return;
//     }

//     setMyFilter((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const setCustomer = (patch) => {
//     setMyFilter((prev) => ({
//       ...prev,
//       customer: {
//         ...(prev.customer || {}),
//         ...patch,
//       },
//     }));
//   };

//   const toYMD = (d) => {
//     if (!d) return "";
//     const x = dayjs(d);
//     return x.isValid() ? x.format("YYYY-MM-DD") : "";
//   };

//   const supportLengthFromSupportDuration = (supportDuration) => {
//     const n = parseInt(String(supportDuration || "1").match(/\d+/)?.[0] || "1", 10);
//     return `${n * 12}M`;
//   };

//   // ✅ calculate payload: language -> tr/de/en/...
//   const buildCalculateBody = () => {
//     const moduleList = Object.entries(myFilter.selectedModules || {}).map(([code, v]) => {
//       const item = { code };

//       const q = Number(v?.quantity || 0);
//       if (q > 0) item.number = q;

//       const m = Number(v?.duration || 0);
//       if (m > 0) item.month = m;

//       return item;
//     });

//     return {
//       numberOfUser: Number(myFilter.userCount || 0),
//       numberOfDatabase: Number(myFilter.dbCount || 0),
//       language: apiLanguageFromUi(myFilter.language),
//       productPackId: Number(myFilter.packId),
//       resellerId: Number(myFilter.partnerId),
//       moduleList,
//     };
//   };

//   const fetchCalculateSalesPrice = async () => {
//     if (!myFilter.packId || !myFilter.partnerId) return;
//     if (!myFilter.userCount || !myFilter.dbCount) return;

//     const selectedCount = Object.keys(myFilter.selectedModules || {}).length;
//     if (selectedCount === 0) {
//       setCalcData(null);
//       setCalcByModule({});
//       return;
//     }

//     setIsCalculating(true);
//     setCalcError("");
//     setCalcData(null);
//     setCalcByModule({});

//     try {
//       const body = buildCalculateBody();
//       const calc = await PartnerApi.calculateSalesPrice(body); // ✅ PartnerApi’ye dokunmadık

//       const list = calc?.calculatePriceList || [];
//       const map = {};
//       list.forEach((x) => {
//         if (x?.moduleCode) map[x.moduleCode] = x;
//       });

//       setCalcData(calc);
//       setCalcByModule(map);
//     } catch {
//       setCalcError(t("Price calculation failed."));
//     } finally {
//       setIsCalculating(false);
//     }
//   };

//   // ✅ generate payload: language -> tr/de/en/...
//   const buildGenerateLicenseBody = () => {
//     const moduleList = Object.entries(myFilter.selectedModules || {}).map(([code, v]) => {
//       const item = { code };

//       const q = Number(v?.quantity || 0);
//       if (q > 0) item.number = q;

//       const m = Number(v?.duration || 0);
//       if (m > 0) item.month = m;

//       const finish = toYMD(myFilter.updateField2);
//       if (finish) item.dateModFinish = finish;

//       return item;
//     });

//     const owner =
//       myFilter.customer?.ownerType === "corporate"
//         ? (myFilter.customer?.tradeName || "").trim()
//         : (myFilter.customer?.fullName || "").trim();

//     return {
//       calculatePriceList: {
//         moduleList,
//         numberOfUser: Number(myFilter.userCount || 0),
//         numberOfDatabase: Number(myFilter.dbCount || 0),

//         language: apiLanguageFromUi(myFilter.language),

//         productPackId: Number(myFilter.packId || 0),
//         resellerId: Number(myFilter.partnerId || 0),

//         supporterId: Number(myFilter.supportArea || 0),
//         codeSupport: String(myFilter.supportType || "").trim(),
//         supportLength: supportLengthFromSupportDuration(myFilter.supportDuration),
//       },

//       isDemo: 0,
//       owner,

//       country: (myFilter.country || myFilter.customer?.country || "Türkiye").toString(),

//       // ✅ backend string dili
//       language: apiLanguageFromUi(myFilter.language),

//       reference: (myFilter.customer?.reference || "").toString(),
//       group: (myFilter.customer?.group || "").toString(),
//       note: (myFilter.customer?.note || "").toString(),

//       newFinishDate: toYMD(myFilter.updateField2),
//       supportStart: toYMD(myFilter.updateField1),
//     };
//   };

//   const goPrevStep = () => setStep((s) => Math.max(1, s - 1));

//   const goNextStep = async () => {
//     if (step === 1) {
//       if (!myFilter.packId || !myFilter.partnerId) return;

//       try {
//         setLoadingModules(true);

//         const data = await PartnerApi.getSalesModuleList({
//           language: apiLanguageFromUi(myFilter.language), // ✅ burada da map
//           resellerId: myFilter.partnerId,
//           productPackId: myFilter.packId,
//         });

//         // senin API örneğin: { salesModuleList: [...] }
//         const list = Array.isArray(data) ? data : data?.salesModuleList || data?.moduleList || data?.data || [];

//         const options = (list || [])
//           .filter((m) => m?.name?.trim())
//           .sort((a, b) => a.name.localeCompare(b.name))
//           .map((m) => ({
//             label: m.name.trim(),
//             value: m.moduleCode,
//             nbComputerMin: m.nbComputerMin,
//             nbComputerMax: m.nbComputerMax,
//             nbComputerStep: m.nbComputerStep,
//             nbDatabaseMax: m.nbDatabaseMax,
//             isLimitedDate: m.isLimitedDate,
//             isLimitedNbDevice: m.isLimitedNbDevice,
//           }));

//         setModuleOptions(options);
//         setStep(2);
//       } catch {
//         setModuleOptions([]);
//         setStep(2);
//       } finally {
//         setLoadingModules(false);
//       }
//       return;
//     }

//     if (step === 2) {
//       const newErrors = {};

//       if (!myFilter.userCount) newErrors.userCount = t("This field is required and cannot be empty.");
//       if (!myFilter.dbCount) newErrors.dbCount = t("This field is required and cannot be empty.");
//       if (!String(myFilter.supportType || "").trim()) newErrors.supportType = t("This field is required and cannot be empty.");

//       setErrors(newErrors);
//       if (Object.keys(newErrors).length > 0) return;

//       setStep(3);
//       fetchCalculateSalesPrice();
//       return;
//     }

//     if (step === 3) {
//       setStep(4);
//       return;
//     }

//     if (step === 4) {
//       handleCreateLicence();
//     }
//   };

// const navigate = useNavigate();


// const handleCreateLicence = async () => {
//   const failMsg = t("License generation failed.");

//   const closeWithError = (msg) => {
//     const m = msg || failMsg;
//     setGenError(m);
//     dispatch(error({ message: m, delay: 4000 }));
//     // ✅ hata olunca modal kapat
//     setOpen(false);
//   };

//   setGenError("");
//   setGeneratedLicenseId(null);

//   // minimum kontroller (senin mevcut mantığın)
//   if (!myFilter.packId || !myFilter.partnerId) return closeWithError(failMsg);
//   if (!myFilter.userCount || !myFilter.dbCount) return closeWithError(failMsg);

//   const owner =
//     myFilter.customer?.ownerType === "corporate"
//       ? (myFilter.customer?.tradeName || "").trim()
//       : (myFilter.customer?.fullName || "").trim();

//   if (!owner) return closeWithError(failMsg);

//   const email = (myFilter.customer?.email || "").trim();
//   const isEmailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   if (!email || !isEmailOk) {
//     return closeWithError(t("Geçerli bir e-posta giriniz."));
//   }

//   setIsGenerating(true);

//   try {
//     const payload = buildGenerateLicenseBody();
//     const res = await PartnerApi.postGenerateLicense(payload);

//     const id = res?.license?.id ?? res?.licenseId ?? null;

//     if (!id) {
//       return closeWithError(t("License created but ID not returned."));
//     }

//     setGeneratedLicenseId(id);

//     dispatch(
//       success({
//         message: `${t("Successfuly License created.")} ID: ${id}`,
//         delay: 3000,
//       })
//     );

//     // ✅ başarılıysa modal kapat
//     setOpen(false);

//     // ✅ Query yazma. State ile id taşı.
//     // AdminLicensePage bu id'yi alıp URL'i "/" yapacak.
//     navigate("/admin/license", {
//       replace: true,
//       state: {
//         licenseId: id,
//         tabId: null,
//         language: i18n.language || "tr", // istersen tut (AdminLicensePage isterse kullanır)
//       },
//     });
//   } catch (e) {
//     const msg =
//       e?.response?.data?.error?.more ||
//       e?.response?.data?.error?.message ||
//       e?.message ||
//       failMsg;

//     closeWithError(msg);
//   } finally {
//     setIsGenerating(false);
//   }
// };

//   const modalTitle = useMemo(() => {
//     if (step === 1) return `${t("AKEAD products")} - ${t("Step")} 1`;
//     if (step === 2) return `${selectedPackLabel} - ${t("Step")} 2`;
//     if (step === 3) return `${t("Faturalama")} - ${t("Step")} 3`;
//     return `${t("Müşteri")} - ${t("Step")} 4`;
//   }, [step, selectedPackLabel, t]);

//   return (
//     <Modal
//       title={
//         <div className="mb-2 text-left">
//           <h3 className="font-bold text-xl md:text-2xl text-gray-800 dark:text-gray-100">
//             {modalTitle}
//           </h3>
//         </div>
//       }
//       open={open}
//       onCancel={closeModal}
//       footer={null}
//       width={820}
//       getContainer={() => document.body}
//       styles={{
//         content: {
//           maxHeight: "90vh",
//           display: "flex",
//           flexDirection: "column",
//         },
//         body: {
//           flex: 1,
//           overflowY: "auto",
//           overflowX: "hidden",
//         },
//       }}
//       className="
//         z-[1200]
//         [&_.ant-modal-header]:bg-transparent
//         [&_.ant-modal-header]:border-b-0
//         dark:[&_.ant-modal-title]:text-white
//         dark:[&_.ant-modal-close]:text-white
//         dark:[&_.ant-modal-close:hover]:text-white
//         dark:[&_.ant-modal-close svg]:fill-white
//         text-left
//       "
//     >
//       {/* STEP 1 */}
//       {step === 1 && (
//         <div className="flex flex-col gap-4 text-left text-gray-900 dark:text-gray-100">
//           {/* Product */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelCls}>{t("Product")}:</label>
//             <div className="flex-1 w-full">
//               <select name="packId" value={myFilter.packId || ""} onChange={onChange} className={selectCls}>
//                 <option value="">{t("Select")}</option>
//                 {packOptions.map((p) => (
//                   <option key={p.value} value={p.value}>
//                     {p.label}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Partner */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelCls}>{t("Partner")}:</label>
//             <div className="flex-1 w-full">
//               <select name="partnerId" value={myFilter.partnerId || ""} onChange={onChange} className={selectCls}>
//                 <option value="">{t("Select")}</option>
//                 {partnerOptions.map((p) => (
//                   <option key={p.value} value={p.value}>
//                     {p.label}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {(isLoadingPacks || isLoadingPartners) && (
//             <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
//               <Spin size="small" />
//               <span>{t("Loading")}…</span>
//             </div>
//           )}

//           <Button
//             onClick={goNextStep}
//             disabled={!myFilter.packId || !myFilter.partnerId || isLoadingPacks || isLoadingPartners}
//             style={primaryBtnStyle}
//             block
//           >
//             {isLoadingModules ? t("Loading") : t("NextStep")}
//           </Button>
//         </div>
//       )}

//       {/* STEP 2 */}
//       {step === 2 && (
//         <div className="flex flex-col gap-4 text-left text-gray-900 dark:text-gray-100">
//           {/* Number of Users */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelWideCls}>{t("Number of Users")}:</label>
//             <div className="flex-1 w-full">
//               <select
//                 name="userCount"
//                 value={myFilter.userCount || ""}
//                 onChange={onChange}
//                 className={errors.userCount ? selectErrCls : selectCls}
//               >
//                 <option value="">{t("Select")}</option>
//                 {selectedPack && selectedPack.maxUser > 0
//                   ? [...Array(selectedPack.maxUser).keys()].map((i) => (
//                       <option key={i + 1} value={String(i + 1)}>
//                         {i + 1}
//                       </option>
//                     ))
//                   : [1].map((num) => (
//                       <option key={num} value={String(num)}>
//                         {num}
//                       </option>
//                     ))}
//               </select>
//               {errors.userCount && <p className="text-red-500 text-sm mt-1">* {errors.userCount}</p>}
//             </div>
//           </div>

//           {/* Number of Databases */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelWideCls}>{t("Number of Databases")}:</label>
//             <div className="flex-1 w-full">
//               <select
//                 name="dbCount"
//                 value={myFilter.dbCount || ""}
//                 onChange={onChange}
//                 className={errors.dbCount ? selectErrCls : selectCls}
//               >
//                 <option value="">{t("Select")}</option>
//                 {selectedPack && selectedPack.maxDatabase > 0
//                   ? [...Array(selectedPack.maxDatabase).keys()].map((i) => (
//                       <option key={i + 1} value={String(i + 1)}>
//                         {i + 1}
//                       </option>
//                     ))
//                   : [1].map((num) => (
//                       <option key={num} value={String(num)}>
//                         {num}
//                       </option>
//                     ))}
//               </select>
//               {errors.dbCount && <p className="text-red-500 text-sm mt-1">* {errors.dbCount}</p>}
//             </div>
//           </div>

//           {/* Modules */}
//           <div className="border-gray-200">
//             <div className="ml-0">
//               <span className="text-red-500">*</span>&nbsp;
//               <label className={labelWideCls}>Lütfen Modülleri Seçiniz:</label>

//               {isLoadingModules && (
//                 <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300 mt-2">
//                   <Spin size="small" />
//                   <span>{t("Loading modules…")}</span>
//                 </div>
//               )}

//               {!isLoadingModules && moduleOptions?.length > 0 && (
//                 <div className={panelBoxCls}>
//                   {(() => {
//                     const showQtyCol = moduleOptions.some((m) => m.isLimitedNbDevice === true);
//                     const showDurCol = moduleOptions.some((m) => m.isLimitedDate === true);

//                     return (
//                       <>
//                         <div className="grid grid-cols-3 font-medium border-b border-gray-200 dark:border-gray-800 pb-2 mb-2">
//                           <span className="col-span-1 text-left">{t("MODULES")}</span>
//                           <span className="text-left">{showQtyCol ? t("Quantity") : ""}</span>
//                           <span className="text-left">{showDurCol ? t("Duration (Months)") : ""}</span>
//                         </div>

//                         <div className="space-y-2 max-h-80 min-h-16 overflow-y-auto pr-1">
//                           {moduleOptions.map((mod) => {
//                             const minQ = mod.nbComputerMin ?? 1;
//                             const stepQ = mod.nbComputerStep ?? 1;
//                             const maxQ = mod.nbComputerMax ?? minQ;

//                             const quantities =
//                               maxQ >= minQ
//                                 ? Array.from(
//                                     { length: Math.floor((maxQ - minQ) / stepQ) + 1 },
//                                     (_, i) => minQ + i * stepQ
//                                   )
//                                 : [1];

//                             const durations = Array.from({ length: 12 }, (_, i) => i + 1);
//                             const isSelected = !!myFilter.selectedModules?.[mod.value];

//                             const showQty = mod.isLimitedNbDevice === true; // ✅ Adet şartı
//                             const showDur = mod.isLimitedDate === true; // ✅ Süre şartı

//                             return (
//                               <div key={mod.value} className="grid grid-cols-3 items-center gap-2">
//                                 <div className="flex items-center gap-2">
//                                   <input
//                                     type="checkbox"
//                                     checked={isSelected}
//                                     onChange={(e) => {
//                                       const checked = e.target.checked;
//                                       setMyFilter((prev) => {
//                                         if (checked) {
//                                           return {
//                                             ...prev,
//                                             selectedModules: {
//                                               ...prev.selectedModules,
//                                               [mod.value]: {
//                                                 name: mod.label,
//                                                 ...(showQty ? { quantity: minQ } : {}),
//                                                 ...(showDur ? { duration: 1 } : {}),
//                                               },
//                                             },
//                                             billing: {
//                                               ...(prev.billing || {}),
//                                               [mod.value]:
//                                                 prev.billing?.[mod.value] || { customerPrice: "" },
//                                             },
//                                           };
//                                         } else {
//                                           const updated = { ...prev.selectedModules };
//                                           delete updated[mod.value];

//                                           const updatedBilling = { ...(prev.billing || {}) };
//                                           delete updatedBilling[mod.value];

//                                           return {
//                                             ...prev,
//                                             selectedModules: updated,
//                                             billing: updatedBilling,
//                                           };
//                                         }
//                                       });
//                                     }}
//                                     className="h-4 w-4"
//                                   />
//                                   <span className="text-gray-900 dark:text-gray-100">{mod.label}</span>
//                                 </div>

//                                 {/* ✅ Quantity: sadece showQty true ise */}
//                                 {showQty ? (
//                                   <select
//                                     value={myFilter.selectedModules?.[mod.value]?.quantity ?? minQ}
//                                     onChange={(e) => {
//                                       const val = Number(e.target.value);
//                                       setMyFilter((prev) => ({
//                                         ...prev,
//                                         selectedModules: {
//                                           ...prev.selectedModules,
//                                           [mod.value]: {
//                                             ...prev.selectedModules?.[mod.value],
//                                             quantity: val,
//                                           },
//                                         },
//                                       }));
//                                     }}
//                                     disabled={!isSelected}
//                                     className={inlineSelectCls}
//                                   >
//                                     {quantities.map((q) => (
//                                       <option key={q} value={q}>
//                                         {q}
//                                       </option>
//                                     ))}
//                                   </select>
//                                 ) : (
//                                   <div className="h-9" />
//                                 )}

//                                 {/* ✅ Duration: sadece showDur true ise */}
//                                 {showDur ? (
//                                   <select
//                                     value={myFilter.selectedModules?.[mod.value]?.duration || 1}
//                                     onChange={(e) => {
//                                       const val = Number(e.target.value);
//                                       setMyFilter((prev) => ({
//                                         ...prev,
//                                         selectedModules: {
//                                           ...prev.selectedModules,
//                                           [mod.value]: {
//                                             ...prev.selectedModules?.[mod.value],
//                                             duration: val,
//                                           },
//                                         },
//                                       }));
//                                     }}
//                                     disabled={!isSelected}
//                                     className={inlineSelectCls}
//                                   >
//                                     {durations.map((d) => (
//                                       <option key={d} value={d}>
//                                         {d} Ay
//                                       </option>
//                                     ))}
//                                   </select>
//                                 ) : (
//                                   <div className="h-9" />
//                                 )}
//                               </div>
//                             );
//                           })}
//                         </div>
//                       </>
//                     );
//                   })()}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Support Type */}
//           <div className="flex flex-col md:flex-row items-start gap-2 mt-1">
//             <label className={labelWideCls}>
//               <span className="text-red-500 mr-1">*</span>
//               {t("Support Type")}
//             </label>
//             <div className="flex-1 w-full">
//               <select
//                 name="supportType"
//                 value={myFilter.supportType}
//                 onChange={onChange}
//                 className={errors.supportType ? selectErrCls : selectCls}
//               >
//                 <option value="">{t("Select")}</option>
//                 <option value="A0">Güncelleme</option>
//                 <option value="A1">Telefonla</option>
//                 <option value="A2">Uzak bağlantı</option>
//                 <option value="A3">Yerinde destek</option>
//               </select>
//               {errors.supportType && <p className="text-red-500 text-sm mt-1">* {errors.supportType}</p>}
//             </div>
//           </div>

//           {/* Support */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelWideCls}>{t("Support")}</label>
//             <select name="supportArea" value={myFilter.supportArea || ""} onChange={onChange} className={selectCls}>
//               <option value="">{t("Select")}</option>
//               {partnerOptions.map((partner) => (
//                 <option key={partner.value} value={partner.value}>
//                   {partner.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Support Duration */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelWideCls}>{t("Support Duration")}:</label>
//             <select name="supportDuration" value={myFilter.supportDuration} onChange={onChange} className={selectCls}>
//               <option value="1year">1 Yıl</option>
//               <option value="2year">2 Yıl (-10%)</option>
//               <option value="3year">3 Yıl (-15%)</option>
//               <option value="4year">4 Yıl (-20%)</option>
//               <option value="5year">5 Yıl (-25%)</option>
//             </select>
//           </div>

//           {/* Support & Updates */}
//           <div className="flex flex-col md:flex-row items-start gap-2">
//             <label className={labelWideCls}>{t("Support & Updates")}:</label>
//             <input
//               name="updateField1"
//               value={formatDateByLang(myFilter.updateField1, i18n.language)}
//               readOnly
//               className={readonlyCls}
//             />
//             <input
//               name="updateField2"
//               value={formatDateByLang(myFilter.updateField2, i18n.language)}
//               readOnly
//               className={readonlyCls}
//             />
//           </div>

//           <div className="flex justify-between mt-2">
//             <Button onClick={goPrevStep} style={secondaryBtnStyle}>
//               {t("Previous Step")}
//             </Button>
//             <Button onClick={goNextStep} style={primaryBtnStyle}>
//               {t("Next Step")}
//             </Button>
//           </div>
//         </div>
//       )}

//       {/* STEP 3 */}
//       {step === 3 &&
//         (() => {
//           const totals = getTotals();
//           const selectedEntries = Object.entries(myFilter.selectedModules || {});
//           const hasSelected = selectedEntries.length > 0;

//           return (
//             <div className="flex flex-col gap-3 text-left text-gray-900 dark:text-gray-100">
//               {isCalculating && (
//                 <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
//                   <Spin size="small" />
//                   <span>{t("Calculating price…")}</span>
//                 </div>
//               )}

//               {!!calcError && <div className="text-red-600 dark:text-red-400 text-sm">{calcError}</div>}

//               <div className="rounded-md border border-gray-200 dark:border-gray-700 overflow-hidden bg-white dark:bg-gray-900">
//                 <div className="grid grid-cols-12 bg-gray-100 dark:bg-gray-800 text-sm font-semibold">
//                   <div className="col-span-7 px-3 py-2 border-r border-gray-200 dark:border-gray-700">{t("Tanım")}</div>
//                   <div className="col-span-3 px-3 py-2 border-r border-gray-200 dark:border-gray-700">{t("Referans")}</div>
//                   <div className="col-span-2 px-3 py-2 text-right">{t("Son Müşteri Fiyatı")}</div>
//                 </div>

//                 <div className="grid grid-cols-12">
//                   <div className="col-span-7 px-3 py-2 border-r border-gray-200 dark:border-gray-700">
//                     <div className="text-sm font-semibold">
//                       BASIC LICENSE{" "}
//                       <span className="font-normal text-xs text-gray-600 dark:text-gray-400">
//                         ({t("Kullanıcı Sayısı")}: {myFilter.userCount || "-"}, {t("Veritabanı Sayısı")}:{" "}
//                         {myFilter.dbCount || "-"})
//                       </span>
//                     </div>

//                     <div className="mt-2 space-y-1">
//                       {hasSelected &&
//                         selectedEntries.map(([code, m]) => (
//                           <div key={code} className="flex gap-1.5">
//                             <span className="mt-0.5 h-4 w-4 flex items-center justify-center rounded-full bg-green-600 text-white text-[10px]">
//                               ✓
//                             </span>
//                             <div className="text-sm font-medium">{m?.name || code}</div>
//                           </div>
//                         ))}

//                       <div className="flex gap-1.5 pt-1">
//                         <span className="mt-0.5 h-4 w-4 flex items-center justify-center rounded-full bg-green-600 text-white text-[10px]">
//                           ✓
//                         </span>
//                         <div>
//                           <div className="text-sm font-medium">{t("Destek ve Güncelleme")}</div>
//                           <div className="text-xs text-gray-600 dark:text-gray-400">
//                             {formatDateByLang(myFilter.updateField1, i18n.language)} –{" "}
//                             {formatDateByLang(myFilter.updateField2, i18n.language)}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-span-3 px-3 py-2 border-r border-gray-200 dark:border-gray-700">
//                     <div className="space-y-1 text-sm">
//                       {hasSelected ? (
//                         selectedEntries.map(([code]) => {
//                           const row = calcByModule?.[code];
//                           return (
//                             <div key={code} className="font-medium">
//                               {row?.reference || "-"}
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <div className="text-gray-500">-</div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-span-2 px-3 py-2 text-right">
//                     <div className="space-y-1 text-sm">
//                       {hasSelected ? (
//                         selectedEntries.map(([code]) => {
//                           const row = calcByModule?.[code] || {};
//                           return (
//                             <div key={code} className="font-semibold">
//                               {money(row.licensePrice)} {totals.currency}
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <div className="text-gray-500">-</div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-12 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
//                   <div className="col-span-7" />
//                   <div className="col-span-5 grid grid-cols-2 text-sm">
//                     <div className="px-3 py-1 font-medium">{t("Toplam (Genel)")}</div>
//                     <div className="px-3 py-1 text-right font-semibold">
//                       {money(totals.totalGeneral)} {totals.currency}
//                     </div>

//                     <div className="px-3 py-1 font-medium">{t("Bayi İndirim")}</div>
//                     <div className="px-3 py-1 text-right">%{Math.round(totals.discountRate * 100)}</div>

//                     <div className="px-3 py-1 font-semibold">{t("Toplam (Bayi)")}</div>
//                     <div className="px-3 py-1 text-right font-semibold">
//                       {money(totals.totalReseller)} {totals.currency}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* 2. Tablo */}
//               <div className="rounded-md border border-gray-200 dark:border-gray-700 overflow-hidden bg-white dark:bg-gray-900">
//                 <div className="px-3 py-2 bg-gray-100 dark:bg-gray-800 text-sm font-semibold">
//                   {t("Tavsiye Edilen Fiyat ve Hizmetler")}
//                 </div>

//                 <div className="grid grid-cols-12">
//                   <div className="col-span-10 px-3 py-2 border-r border-gray-200 dark:border-gray-700 text-xs space-y-1">
//                     <div>{t("Yazılım")}</div>
//                     <div>{t("Destek ve Güncelleme")}</div>
//                     <div>{t("Kurulum")}</div>
//                     <div>{t("Eğitim")}</div>
//                   </div>

//                   <div className="col-span-2 px-3 py-2 text-xs text-right space-y-1">
//                     <div className="font-semibold">
//                       {money(totals.lic)} {totals.currency}
//                     </div>
//                     <div className="font-semibold">
//                       {money(totals.upd)} {totals.currency}
//                     </div>
//                     <div className="font-semibold">
//                       {money(totals.ins)} {totals.currency}
//                     </div>
//                     <div className="font-semibold">
//                       {money(totals.trn)} {totals.currency}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-12 border-t border-gray-200 dark:border-gray-700">
//                   <div className="col-span-10 px-3 py-2 bg-blue-600 text-white font-semibold text-sm">{t("Toplam")}</div>
//                   <div className="col-span-2 px-3 py-2 text-right font-semibold text-sm bg-blue-600 text-white">
//                     {money(totals.totalGeneral)} {totals.currency}
//                   </div>
//                 </div>
//               </div>

//               <div className="flex justify-between pt-1">
//                 <Button onClick={goPrevStep} style={secondaryBtnStyle}>
//                   {t("Previous Step")}
//                 </Button>
//                 <Button onClick={goNextStep} style={primaryBtnStyle}>
//                   {t("Next Step")}
//                 </Button>
//               </div>
//             </div>
//           );
//         })()}

//       {/* STEP 4 */}
//       {step === 4 && (
//         <div className="flex flex-col gap-4 text-left text-gray-900 dark:text-gray-100">
//           {/* Lisansın Sahibi */}
//           <div className="flex flex-col md:flex-row items-start gap-3">
//             <label className={labelWideCls}>{t("Lisansın Sahibi")}</label>
//             <Radio.Group value={myFilter.customer.ownerType} onChange={(e) => setCustomer({ ownerType: e.target.value })}>
//               <Radio value="corporate">{t("Kurumsal")}</Radio>
//               <Radio value="personal">{t("Şahıs")}</Radio>
//             </Radio.Group>
//           </div>

//           {!!genError && <div className="text-red-600 dark:text-red-400 text-sm">{genError}</div>}

//           {/* Kurumsal */}
//           {myFilter.customer.ownerType === "corporate" && (
//             <div className="grid grid-cols-12 gap-3">
//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Tam ticaret unvanı")}</div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.tradeName} onChange={(e) => setCustomer({ tradeName: e.target.value })} />
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("Temsilci Adı")}
//               </div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.representativeName} onChange={(e) => setCustomer({ representativeName: e.target.value })} />
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("Temsilci Pozisyonu")}
//               </div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.representativeTitle} onChange={(e) => setCustomer({ representativeTitle: e.target.value })} />
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("E-Posta")}
//               </div>
//               <div className="col-span-8">
//                 <input
//                   type="email"
//                   inputMode="email"
//                   autoComplete="email"
//                   className={errors.email ? selectErrCls : inputCls}
//                   value={myFilter.customer.email}
//                   onChange={(e) => {
//                     const v = e.target.value;
//                     setCustomer({ email: v });

//                     const trimmed = v.trim();
//                     if (!trimmed) {
//                       setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
//                       return;
//                     }

//                     const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
//                     setErrors((p) => ({ ...p, email: ok ? "" : t("Geçerli bir e-posta giriniz.") }));
//                   }}
//                   onBlur={() => {
//                     const v = (myFilter.customer.email || "").trim();
//                     if (!v) {
//                       setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
//                       return;
//                     }
//                     const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
//                     if (!ok) setErrors((p) => ({ ...p, email: t("Geçerli bir e-posta giriniz.") }));
//                   }}
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">* {errors.email}</p>}
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("Ticaret Sicil Numarası")}
//               </div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.tradeRegistryNo} onChange={(e) => setCustomer({ tradeRegistryNo: e.target.value })} />
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("Adres")}
//               </div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.address} onChange={(e) => setCustomer({ address: e.target.value })} />
//               </div>
//             </div>
//           )}

//           {/* Şahıs */}
//           {myFilter.customer.ownerType === "personal" && (
//             <div className="grid grid-cols-12 gap-3">
//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Ad / Soyad")}</div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.fullName} onChange={(e) => setCustomer({ fullName: e.target.value })} />
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("E-Posta")}
//               </div>
//               <div className="col-span-8">
//                 <input
//                   type="email"
//                   inputMode="email"
//                   autoComplete="email"
//                   className={errors.email ? selectErrCls : inputCls}
//                   value={myFilter.customer.email}
//                   onChange={(e) => {
//                     const v = e.target.value;
//                     setCustomer({ email: v });

//                     const trimmed = v.trim();
//                     if (!trimmed) {
//                       setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
//                       return;
//                     }

//                     const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
//                     setErrors((p) => ({ ...p, email: ok ? "" : t("Geçerli bir e-posta giriniz.") }));
//                   }}
//                   onBlur={() => {
//                     const v = (myFilter.customer.email || "").trim();
//                     if (!v) {
//                       setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
//                       return;
//                     }
//                     const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
//                     if (!ok) setErrors((p) => ({ ...p, email: t("Geçerli bir e-posta giriniz.") }));
//                   }}
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">* {errors.email}</p>}
//               </div>

//               <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//                 <span className="text-red-500">*</span>&nbsp;{t("Adres")}
//               </div>
//               <div className="col-span-8">
//                 <input className={inputCls} value={myFilter.customer.address} onChange={(e) => setCustomer({ address: e.target.value })} />
//               </div>
//             </div>
//           )}

//           {/* Ortak alanlar */}
//           <div className="grid grid-cols-12 gap-3">
//             <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//               <span className="text-red-500">*</span>&nbsp;{t("Ülke")}
//             </div>
//             <div className="col-span-3">
//               <select
//                 id="country"
//                 name="country"
//                 value={myFilter.country || (countryOptions[0]?.value ?? "")}
//                 onChange={(e) => setMyFilter((p) => ({ ...p, country: e.target.value }))}
//                 className={selectCls}
//               >
//                 {countryOptions.map((opt) => (
//                   <option key={opt.value} value={opt.value}>
//                     {opt.label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-span-2" />

//             <div className="col-span-4 text-right pr-2 pt-2 text-sm">
//               <span className="text-red-500">*</span>&nbsp;{t("Language")}
//             </div>
//             <div className="col-span-3">
//               <select
//                 id="language"
//                 name="language"
//                 value={myFilter.language || (languageOptions[0]?.value ?? "")}
//                 onChange={(e) => setMyFilter((p) => ({ ...p, language: e.target.value }))}
//                 className={selectCls}
//               >
//                 {languageOptions.map((opt) => (
//                   <option key={opt.value} value={opt.value}>
//                     {opt.label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-span-2" />

//             <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Referansınız")}</div>
//             <div className="col-span-8">
//               <input className={inputCls} value={myFilter.customer.reference} onChange={(e) => setCustomer({ reference: e.target.value })} />
//             </div>

//             <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Grup")}</div>
//             <div className="col-span-8">
//               <input className={inputCls} value={myFilter.customer.group} onChange={(e) => setCustomer({ group: e.target.value })} />
//             </div>

//             <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Not")}</div>
//             <div className="col-span-8">
//               <textarea className={textareaCls} value={myFilter.customer.note} onChange={(e) => setCustomer({ note: e.target.value })} />
//             </div>
//           </div>

//           <div className="flex items-center gap-3 mt-1">
//             <input
//               type="checkbox"
//               checked={!!myFilter.customer.directApprove}
//               onChange={(e) => setCustomer({ directApprove: e.target.checked })}
//               className="h-4 w-4"
//             />
//             <span className="text-red-600">{t("Satışları Direkt Onayla")}</span>
//           </div>

//           <div className="flex justify-between pt-2">
//             <Button onClick={goPrevStep} style={secondaryBtnStyle} disabled={isGenerating}>
//               {t("Önceki Adım")}
//             </Button>
//             <Button onClick={handleCreateLicence} style={primaryBtnStyle} disabled={isGenerating}>
//               {isGenerating ? t("Loading") : t("Lisans Oluştur")}
//             </Button>
//           </div>
//         </div>
//       )}
//     </Modal>
//   );
// };

// export default NewLicence;

const NewLicence = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});

  const [isCalculating, setIsCalculating] = useState(false);
  const [calcError, setCalcError] = useState("");
  const [calcData, setCalcData] = useState(null);
  const [calcByModule, setCalcByModule] = useState({});

  const [isGenerating, setIsGenerating] = useState(false);
  const [genError, setGenError] = useState("");
  const [generatedLicenseId, setGeneratedLicenseId] = useState(null);

  const [packOptions, setPackOptions] = useState([]);
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [moduleOptions, setModuleOptions] = useState([]);

  const [isLoadingPacks, setLoadingPacks] = useState(false);
  const [isLoadingPartners, setLoadingPartners] = useState(false);
  const [isLoadingModules, setLoadingModules] = useState(false);

  const [countryOptions, setCountryOptions] = useState([]);

  const primaryBtnStyle = {
    backgroundColor: "#2563eb",
    borderColor: "#2563eb",
    color: "#fff",
    boxShadow: "none",
  };

  const secondaryBtnStyle = {
    backgroundColor: "#6b7280",
    borderColor: "#6b7280",
    color: "#fff",
    boxShadow: "none",
  };

  const baseField = `
    h-9 px-3 border rounded-md w-full
    transition-colors
    bg-white text-gray-900
    border-gray-300
    focus:outline-none focus:ring-1 focus:ring-blue-500
  `;

  const selectCls = baseField;
  const selectErrCls = `${baseField} !border-red-500`;
  const inlineSelectCls = baseField;
  const inputCls = baseField;

  const textareaCls = `
    px-3 py-2 border rounded-md w-full
    transition-colors
    bg-white text-gray-900
    border-gray-300
    focus:outline-none focus:ring-1 focus:ring-blue-500
    min-h-[90px]
  `;

  const readonlyCls = `
    ${baseField}
    bg-gray-100 text-gray-900 cursor-not-allowed
  `;

  const labelCls = `
    min-w-[120px] font-medium
    text-gray-800 dark:text-gray-100
  `;

  const labelWideCls = `
    min-w-[150px] font-medium
    text-gray-800 dark:text-gray-100
  `;

  const panelBoxCls = `
    border border-gray-300 dark:border-gray-800 rounded-md p-3
    bg-gray-50 dark:bg-gray-900 dark:text-gray-100 w-full
    overflow-visible
  `;

  const languageOptions = [
    { label: "TURKISH", value: "40" },
    { label: "GERMAN", value: "1" },
    { label: "ENGLISH", value: "3" },
    { label: "FRENCH", value: "5" },
    { label: "ARABIC", value: "19" },
  ];

  const apiLanguageFromUi = (uiLang) => {
    const x = String(uiLang || "");
    switch (x) {
      case "40":
        return "tr";
      case "1":
        return "de";
      case "3":
        return "en";
      case "12":
        return "nl";
      case "5":
        return "fr";
      case "19":
        return "ar";
      default:
        return "tr";
    }
  };

  const initialState = useMemo(
    () => ({
      productCode: "",
      partnerId: "",
      supportArea: "",
      supportDuration: "1year",
      updateField1: "",
      updateField2: "",
      userCount: "",
      dbCount: "",
      selectedModules: {},
      supportType: "",

      language: "40",
      status: 1,
      country: "",
      packId: "",
      billing: {},

      customer: {
        ownerType: "corporate",
        tradeName: "",
        representativeName: "",
        representativeTitle: "",
        email: "",
        tradeRegistryNo: "",
        address: "",
        country: "Türkiye",
        uiLanguage: "TURKISH",
        reference: "",
        group: "",
        note: "",
        directApprove: false,
        fullName: "",
      },
    }),
    []
  );

  const [myFilter, setMyFilter] = useState(initialState);

  const selectedPack = useMemo(
    () => packOptions.find((p) => p.value === myFilter.packId),
    [packOptions, myFilter.packId]
  );

  const selectedPackLabel = selectedPack?.label || "";

  const resetAll = () => {
    setStep(1);
    setErrors({});

    setMyFilter({
      ...initialState,
      language: initialState.language,
    });

    setPackOptions([]);
    setPartnerOptions([]);
    setModuleOptions([]);

    setLoadingPacks(false);
    setLoadingPartners(false);
    setLoadingModules(false);

    setIsCalculating(false);
    setCalcError("");
    setCalcData(null);
    setCalcByModule({});

    setIsGenerating(false);
    setGenError("");
    setGeneratedLicenseId(null);
  };

  const openModal = async () => {
    resetAll();
    setOpen(true);

    try {
      setLoadingPacks(true);
      const data = await PartnerApi.getPackList({
        language: i18n.language || "tr",
        status: 1,
      });

      const list = data?.packList || data?.data || [];
      const options = list.map((item) => ({
        value: item.id,
        productCode: item.productCode,
        productName: item.productName,
        packName: item.packName,
        label: `${item.productName || ""} + ${item.packName || ""}`,
        maxUser: item.maxUser || 0,
        maxDatabase: item.maxDatabase || 0,
      }));

      setPackOptions(options);
    } catch {
      setPackOptions([]);
    } finally {
      setLoadingPacks(false);
    }

    try {
      setLoadingPartners(true);
      const pdata = await PartnerApi.getPartnerList({ status: 1 });
      const plist = pdata?.partnerList || pdata?.data || [];
      const popts = plist
        .filter((p) => p?.name)
        .map((p) => ({ value: p.id, label: p.name }));
      setPartnerOptions(popts);
    } catch {
      setPartnerOptions([]);
    } finally {
      setLoadingPartners(false);
    }
  };

  const closeModal = () => setOpen(false);

  useEffect(() => {
    const onOpen = (e) => {
      if (e?.detail?.modal === "new-licence") openModal();
    };
    window.addEventListener("AKEAD:modal-open", onOpen);

    const legacyOpen = () => openModal();
    window.addEventListener("AKEAD:open-new-licence", legacyOpen);

    return () => {
      window.removeEventListener("AKEAD:modal-open", onOpen);
      window.removeEventListener("AKEAD:open-new-licence", legacyOpen);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!open) return;
    const today = dayjs().startOf("day");
    const n = parseInt(myFilter.supportDuration.match(/\d+/)?.[0] || "1", 10);

    setMyFilter((p) => ({
      ...p,
      updateField1: today.toDate(),
      updateField2: today.add(n, "year").add(15, "day").toDate(),
    }));
  }, [open, myFilter.supportDuration]);

  useEffect(() => {
    if (!open) return;

    setModuleOptions([]);
    setMyFilter((p) => ({
      ...p,
      selectedModules: {},
      billing: {},
      userCount: "",
      dbCount: "",
    }));

    setCalcError("");
    setCalcData(null);
    setCalcByModule({});
    if (step > 1) setStep(1);
  }, [open, myFilter.partnerId, myFilter.packId]);

  useEffect(() => {
    if (!open) return;
    if (!selectedPack) return;

    const userAuto =
      selectedPack.maxUser > 0 ? (selectedPack.maxUser === 1 ? "1" : "") : "1";
    const dbAuto =
      selectedPack.maxDatabase > 0
        ? (selectedPack.maxDatabase === 1 ? "1" : "")
        : "1";

    setMyFilter((prev) => ({
      ...prev,
      userCount: prev.userCount || userAuto,
      dbCount: prev.dbCount || dbAuto,
    }));
  }, [open, selectedPack]);

  // useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await PartnerApi.getCountryList({
          language: apiLanguageFromUi(myFilter.language),
          status: myFilter.status,
          limit: 500,
          offset: 0,
        });

        const list = data?.countryList || [];
        const options = list
          .filter((c) => c.name?.trim())
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((c) => ({ label: c.name.trim(), value: c.id }));

        setCountryOptions(options);

        if (!myFilter.country && options.length > 0) {
          setMyFilter((prev) => ({ ...prev, country: options[0].value }));
        }
      } catch (err) {
        console.error("Ülke listesi alınamadı:", err);
      }
    };

    // fetchCountries();
  // }, [myFilter.language, myFilter.status, myFilter.country]);

  const money = (val) => {
    const n = Number(val || 0);
    return Number.isFinite(n) ? n.toFixed(2) : "0.00";
  };

  const getTotals = () => {
    const currency = calcData?.currencyCode || "TRY";

    const lic = Number(calcData?.totalLicensePrice || 0);
    const ins = Number(calcData?.totalInstallPrice || 0);
    const trn = Number(calcData?.totalTrainingPrice || 0);
    const upd = Number(calcData?.totalUpdatePrice || 0);

    const totalGeneral = lic + ins + trn + upd;

    const discountRate = Number(calcData?.discountRate || 0);
    const totalReseller = totalGeneral * (1 - discountRate);

    return {
      currency,
      lic,
      ins,
      trn,
      upd,
      totalGeneral,
      discountRate,
      totalReseller,
    };
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === "packId") {
      const valNum = value ? Number(value) : "";
      const found = packOptions.find((p) => p.value === valNum);

      setMyFilter((prev) => ({
        ...prev,
        packId: valNum,
        productCode: found?.productCode || "",
      }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    setMyFilter((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const setCustomer = (patch) => {
    setMyFilter((prev) => ({
      ...prev,
      customer: {
        ...(prev.customer || {}),
        ...patch,
      },
    }));
  };

  const toYMD = (d) => {
    if (!d) return "";
    const x = dayjs(d);
    return x.isValid() ? x.format("YYYY-MM-DD") : "";
  };

  const supportLengthFromSupportDuration = (supportDuration) => {
    const n = parseInt(
      String(supportDuration || "1").match(/\d+/)?.[0] || "1",
      10
    );
    return `${n * 12}M`;
  };

  const buildCalculateBody = () => {
    const moduleList = Object.entries(myFilter.selectedModules || {}).map(
      ([code, v]) => {
        const item = { code };

        const q = Number(v?.quantity || 0);
        if (q > 0) item.number = q;

        const m = Number(v?.duration || 0);
        if (m > 0) item.month = m;

        return item;
      }
    );

    return {
      numberOfUser: Number(myFilter.userCount || 0),
      numberOfDatabase: Number(myFilter.dbCount || 0),
      language: apiLanguageFromUi(myFilter.language),
      productPackId: Number(myFilter.packId),
      resellerId: Number(myFilter.partnerId),
      moduleList,
    };
  };

  const fetchCalculateSalesPrice = async () => {
    if (!myFilter.packId || !myFilter.partnerId) return;
    if (!myFilter.userCount || !myFilter.dbCount) return;

    const selectedCount = Object.keys(myFilter.selectedModules || {}).length;
    if (selectedCount === 0) {
      setCalcData(null);
      setCalcByModule({});
      return;
    }

    setIsCalculating(true);
    setCalcError("");
    setCalcData(null);
    setCalcByModule({});

    try {
      const body = buildCalculateBody();
      const calc = await PartnerApi.calculateSalesPrice(body);

      const list = calc?.calculatePriceList || [];
      const map = {};
      list.forEach((x) => {
        if (x?.moduleCode) map[x.moduleCode] = x;
      });

      setCalcData(calc);
      setCalcByModule(map);
    } catch {
      setCalcError(t("Price calculation failed."));
    } finally {
      setIsCalculating(false);
    }
  };

  const buildGenerateLicenseBody = () => {
    const moduleList = Object.entries(myFilter.selectedModules || {}).map(
      ([code, v]) => {
        const item = { code };

        const q = Number(v?.quantity || 0);
        if (q > 0) item.number = q;

        const m = Number(v?.duration || 0);
        if (m > 0) item.month = m;

        const finish = toYMD(myFilter.updateField2);
        if (finish) item.dateModFinish = finish;

        return item;
      }
    );

    const owner =
      myFilter.customer?.ownerType === "corporate"
        ? (myFilter.customer?.tradeName || "").trim()
        : (myFilter.customer?.fullName || "").trim();

    return {
      calculatePriceList: {
        moduleList,
        numberOfUser: Number(myFilter.userCount || 0),
        numberOfDatabase: Number(myFilter.dbCount || 0),

        language: apiLanguageFromUi(myFilter.language),

        productPackId: Number(myFilter.packId || 0),
        resellerId: Number(myFilter.partnerId || 0),

        supporterId: Number(myFilter.supportArea || 0),
        codeSupport: String(myFilter.supportType || "").trim(),
        supportLength: supportLengthFromSupportDuration(myFilter.supportDuration),
      },

      isDemo: 0,
      owner,

      country: (myFilter.country || myFilter.customer?.country || "Türkiye").toString(),

      language: apiLanguageFromUi(myFilter.language),

      reference: (myFilter.customer?.reference || "").toString(),
      group: (myFilter.customer?.group || "").toString(),
      note: (myFilter.customer?.note || "").toString(),

      newFinishDate: toYMD(myFilter.updateField2),
      supportStart: toYMD(myFilter.updateField1),
    };
  };

  const goPrevStep = () => setStep((s) => Math.max(1, s - 1));

  const goNextStep = async () => {
    if (step === 1) {
      if (!myFilter.packId || !myFilter.partnerId) return;

      try {
        setLoadingModules(true);

        const data = await PartnerApi.getSalesModuleList({
          language: apiLanguageFromUi(myFilter.language),
          resellerId: myFilter.partnerId,
          productPackId: myFilter.packId,
        });

        const list = Array.isArray(data)
          ? data
          : data?.salesModuleList || data?.moduleList || data?.data || [];

        const options = (list || [])
          .filter((m) => m?.name?.trim())
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((m) => ({
            label: m.name.trim(),
            value: m.moduleCode,
            nbComputerMin: m.nbComputerMin,
            nbComputerMax: m.nbComputerMax,
            nbComputerStep: m.nbComputerStep,
            nbDatabaseMax: m.nbDatabaseMax,
            isLimitedDate: m.isLimitedDate,
            isLimitedNbDevice: m.isLimitedNbDevice,
          }));

        setModuleOptions(options);
        setStep(2);
      } catch {
        setModuleOptions([]);
        setStep(2);
      } finally {
        setLoadingModules(false);
      }
      return;
    }

    if (step === 2) {
      const newErrors = {};

      if (!myFilter.userCount)
        newErrors.userCount = t("This field is required and cannot be empty.");
      if (!myFilter.dbCount)
        newErrors.dbCount = t("This field is required and cannot be empty.");
      if (!String(myFilter.supportType || "").trim())
        newErrors.supportType = t("This field is required and cannot be empty.");

      setErrors(newErrors);
      if (Object.keys(newErrors).length > 0) return;

      setStep(3);
      fetchCalculateSalesPrice();
      return;
    }

    if (step === 3) {
      setStep(4);
      return;
    }

    if (step === 4) {
      handleCreateLicence();
    }
  };

  const navigate = useNavigate();

  const handleCreateLicence = async () => {
    const failMsg = t("License generation failed.");

    const closeWithError = (msg) => {
      const m = msg || failMsg;
      setGenError(m);
      dispatch(error({ message: m, delay: 4000 }));
      setOpen(false);
    };

    setGenError("");
    setGeneratedLicenseId(null);

    if (!myFilter.packId || !myFilter.partnerId) return closeWithError(failMsg);
    if (!myFilter.userCount || !myFilter.dbCount) return closeWithError(failMsg);

    const owner =
      myFilter.customer?.ownerType === "corporate"
        ? (myFilter.customer?.tradeName || "").trim()
        : (myFilter.customer?.fullName || "").trim();

    if (!owner) return closeWithError(failMsg);

    const email = (myFilter.customer?.email || "").trim();
    const isEmailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!email || !isEmailOk) {
      return closeWithError(t("Geçerli bir e-posta giriniz."));
    }

    setIsGenerating(true);

    try {
      const payload = buildGenerateLicenseBody();
      const res = await PartnerApi.postGenerateLicense(payload);

      const id = res?.license?.id ?? res?.licenseId ?? null;

      if (!id) {
        return closeWithError(t("License created but ID not returned."));
      }

      setGeneratedLicenseId(id);

      dispatch(
        success({
          message: `${t("Successfuly License created.")} ID: ${id}`,
          delay: 3000,
        })
      );

      setOpen(false);

      navigate("/admin/license", {
        replace: true,
        state: {
          licenseId: id,
          tabId: null,
          language: i18n.language || "tr",
        },
      });
    } catch (e) {
      const msg =
        e?.response?.data?.error?.more ||
        e?.response?.data?.error?.message ||
        e?.message ||
        failMsg;

      closeWithError(msg);
    } finally {
      setIsGenerating(false);
    }
  };

  const modalTitle = useMemo(() => {
    if (step === 1) return `${t("AKEAD products")} - ${t("Step")} 1`;
    if (step === 2) return `${selectedPackLabel} - ${t("Step")} 2`;
    if (step === 3) return `${t("Faturalama")} - ${t("Step")} 3`;
    return `${t("Müşteri")} - ${t("Step")} 4`;
  }, [step, selectedPackLabel, t]);

  return (
    <Modal
      title={
        <div className="mb-2 text-left">
          <h3 className="font-bold text-xl md:text-2xl text-gray-800 dark:text-gray-100">
            {modalTitle}
          </h3>
        </div>
      }
      open={open}
      onCancel={closeModal}
      footer={null}
      width={820}
      getContainer={() => document.body}
      closeIcon={
        <span className="text-gray-800 dark:!text-white" style={{ fontSize: 18, lineHeight: 1 }}>
          ✕
        </span>
      }
      styles={{
        content: {
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        },
        body: {
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
        },
        // ✅ X butonunun rengini de garantiye al
        closeButton: {
          color:
            typeof document !== "undefined" &&
              document.documentElement.classList.contains("dark")
              ? "#ffffff"
              : "#111827",
        },
      }}
      className="
        z-[1200]
        [&_.ant-modal-header]:bg-transparent
        [&_.ant-modal-header]:border-b-0
        text-left

        /* ✅ close (X) rengi */
        [&_.ant-modal-close]:!text-gray-800
        dark:[&_.ant-modal-close]:!text-white
        [&_.ant-modal-close-x]:!text-gray-800
        dark:[&_.ant-modal-close-x]:!text-white

        /* ✅ hover/focus arka planı kapat */
        [&_.ant-modal-close:hover]:bg-transparent
        [&_.ant-modal-close:focus]:bg-transparent
        [&_.ant-modal-close:active]:bg-transparent
        [&_.ant-modal-close:focus-visible]:bg-transparent
        [&_.ant-modal-close]:shadow-none
        [&_.ant-modal-close]:outline-none
        [&_.ant-modal-close:focus-visible]:outline-none
      "
    >
      {/* STEP 1 */}
      {step === 1 && (
        <div className="flex flex-col gap-4 text-left text-gray-900 dark:text-gray-100">
          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelCls}>{t("Product")}:</label>
            <div className="flex-1 w-full">
              <select name="packId" value={myFilter.packId || ""} onChange={onChange} className={selectCls}>
                <option value="">{t("Select")}</option>
                {packOptions.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelCls}>{t("Partner")}:</label>
            <div className="flex-1 w-full">
              <select name="partnerId" value={myFilter.partnerId || ""} onChange={onChange} className={selectCls}>
                <option value="">{t("Select")}</option>
                {partnerOptions.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {(isLoadingPacks || isLoadingPartners) && (
            <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
              <Spin size="small" />
              <span>{t("Loading")}…</span>
            </div>
          )}

          <Button
            onClick={goNextStep}
            disabled={!myFilter.packId || !myFilter.partnerId || isLoadingPacks || isLoadingPartners}
            style={primaryBtnStyle}
            block
          >
            {isLoadingModules ? t("Loading") : t("NextStep")}
          </Button>
        </div>
      )}

      {/* STEP 2 */}
      {step === 2 && (
        <div className="flex flex-col gap-4 text-left text-gray-900 dark:text-gray-100">
          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelWideCls}>  <span className="text-red-500">*</span>&nbsp;
              {t("Number of Users")}:</label>
            <div className="flex-1 w-full">
              <select
                name="userCount"
                value={myFilter.userCount || ""}
                onChange={onChange}
                className={errors.userCount ? selectErrCls : selectCls}
              >
                <option value="">{t("Select")}</option>
                {selectedPack && selectedPack.maxUser > 0
                  ? [...Array(selectedPack.maxUser).keys()].map((i) => (
                    <option key={i + 1} value={String(i + 1)}>
                      {i + 1}
                    </option>
                  ))
                  : [1].map((num) => (
                    <option key={num} value={String(num)}>
                      {num}
                    </option>
                  ))}
              </select>
              {errors.userCount && <p className="text-red-500 text-sm mt-1">* {errors.userCount}</p>}
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelWideCls}><span className="text-red-500">*</span>&nbsp;
              {t("Number of Databases")}:</label>
            <div className="flex-1 w-full">
              <select
                name="dbCount"
                value={myFilter.dbCount || ""}
                onChange={onChange}
                className={errors.dbCount ? selectErrCls : selectCls}
              >
                <option value="">{t("Select")}</option>
                {selectedPack && selectedPack.maxDatabase > 0
                  ? [...Array(selectedPack.maxDatabase).keys()].map((i) => (
                    <option key={i + 1} value={String(i + 1)}>
                      {i + 1}
                    </option>
                  ))
                  : [1].map((num) => (
                    <option key={num} value={String(num)}>
                      {num}
                    </option>
                  ))}
              </select>
              {errors.dbCount && <p className="text-red-500 text-sm mt-1">* {errors.dbCount}</p>}
            </div>
          </div>

          <div className="border-gray-200">
            <div className="ml-0">
              <span className="text-red-500">*</span>&nbsp;
              <label className={labelWideCls}>Lütfen Modülleri Seçiniz:</label>

              {isLoadingModules && (
                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300 mt-2">
                  <Spin size="small" />
                  <span>{t("Loading modules…")}</span>
                </div>
              )}

              {!isLoadingModules && moduleOptions?.length > 0 && (
                <div className={panelBoxCls}>
                  {(() => {
                    const showQtyCol = moduleOptions.some((m) => m.isLimitedNbDevice === true);
                    const showDurCol = moduleOptions.some((m) => m.isLimitedDate === true);

                    return (
                      <>
                        <div className="grid grid-cols-3 font-medium border-b border-gray-200 dark:border-gray-800 pb-2 mb-2">
                          <span className="col-span-1 text-left">{t("MODULES")}</span>
                          <span className="text-left">{showQtyCol ? t("Quantity") : ""}</span>
                          <span className="text-left">{showDurCol ? t("Duration (Months)") : ""}</span>
                        </div>

                        <div className="space-y-2 max-h-80 min-h-16 overflow-y-auto pr-1">
                          {moduleOptions.map((mod) => {
                            const minQ = mod.nbComputerMin ?? 1;
                            const stepQ = mod.nbComputerStep ?? 1;
                            const maxQ = mod.nbComputerMax ?? minQ;

                            const quantities =
                              maxQ >= minQ
                                ? Array.from(
                                  { length: Math.floor((maxQ - minQ) / stepQ) + 1 },
                                  (_, i) => minQ + i * stepQ
                                )
                                : [1];

                            const durations = Array.from({ length: 12 }, (_, i) => i + 1);
                            const isSelected = !!myFilter.selectedModules?.[mod.value];

                            const showQty = mod.isLimitedNbDevice === true;
                            const showDur = mod.isLimitedDate === true;

                            return (
                              <div key={mod.value} className="grid grid-cols-3 items-center gap-2">
                                <div className="flex items-center gap-2">
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setMyFilter((prev) => {
                                        if (checked) {
                                          return {
                                            ...prev,
                                            selectedModules: {
                                              ...prev.selectedModules,
                                              [mod.value]: {
                                                name: mod.label,
                                                ...(showQty ? { quantity: minQ } : {}),
                                                ...(showDur ? { duration: 1 } : {}),
                                              },
                                            },
                                            billing: {
                                              ...(prev.billing || {}),
                                              [mod.value]: prev.billing?.[mod.value] || { customerPrice: "" },
                                            },
                                          };
                                        } else {
                                          const updated = { ...prev.selectedModules };
                                          delete updated[mod.value];

                                          const updatedBilling = { ...(prev.billing || {}) };
                                          delete updatedBilling[mod.value];

                                          return {
                                            ...prev,
                                            selectedModules: updated,
                                            billing: updatedBilling,
                                          };
                                        }
                                      });
                                    }}
                                    className="h-4 w-4"
                                  />
                                  <span className="text-gray-900 dark:text-gray-100">{mod.label}</span>
                                </div>

                                {showQty ? (
                                  <select
                                    value={myFilter.selectedModules?.[mod.value]?.quantity ?? minQ}
                                    onChange={(e) => {
                                      const val = Number(e.target.value);
                                      setMyFilter((prev) => ({
                                        ...prev,
                                        selectedModules: {
                                          ...prev.selectedModules,
                                          [mod.value]: {
                                            ...prev.selectedModules?.[mod.value],
                                            quantity: val,
                                          },
                                        },
                                      }));
                                    }}
                                    disabled={!isSelected}
                                    className={inlineSelectCls}
                                  >
                                    {quantities.map((q) => (
                                      <option key={q} value={q}>
                                        {q}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <div className="h-9" />
                                )}

                                {showDur ? (
                                  <select
                                    value={myFilter.selectedModules?.[mod.value]?.duration || 1}
                                    onChange={(e) => {
                                      const val = Number(e.target.value);
                                      setMyFilter((prev) => ({
                                        ...prev,
                                        selectedModules: {
                                          ...prev.selectedModules,
                                          [mod.value]: {
                                            ...prev.selectedModules?.[mod.value],
                                            duration: val,
                                          },
                                        },
                                      }));
                                    }}
                                    disabled={!isSelected}
                                    className={inlineSelectCls}
                                  >
                                    {durations.map((d) => (
                                      <option key={d} value={d}>
                                        {d} Ay
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <div className="h-9" />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    );
                  })()}
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-2 mt-1">
            <label className={labelWideCls}>
              <span className="text-red-500 mr-1">*</span>
              {t("Support Type")}
            </label>
            <div className="flex-1 w-full">
              <select
                name="supportType"
                value={myFilter.supportType}
                onChange={onChange}
                className={errors.supportType ? selectErrCls : selectCls}
              >
                <option value="">{t("Select")}</option>
                <option value="A0">Güncelleme</option>
                <option value="A1">Telefonla</option>
                <option value="A2">Uzak bağlantı</option>
                <option value="A3">Yerinde destek</option>
              </select>
              {errors.supportType && <p className="text-red-500 text-sm mt-1">* {errors.supportType}</p>}
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelWideCls}>{t("Support")}</label>
            <select name="supportArea" value={myFilter.supportArea || ""} onChange={onChange} className={selectCls}>
              <option value="">{t("Select")}</option>
              {partnerOptions.map((partner) => (
                <option key={partner.value} value={partner.value}>
                  {partner.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelWideCls}>{t("Support Duration")}:</label>
            <select name="supportDuration" value={myFilter.supportDuration} onChange={onChange} className={selectCls}>
              <option value="1year">1 Yıl</option>
              <option value="2year">2 Yıl (-10%)</option>
              <option value="3year">3 Yıl (-15%)</option>
              <option value="4year">4 Yıl (-20%)</option>
              <option value="5year">5 Yıl (-25%)</option>
            </select>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-2">
            <label className={labelWideCls}>{t("Support & Updates")}:</label>
            <input
              name="updateField1"
              value={formatDateByLang(myFilter.updateField1, i18n.language)}
              readOnly
              className={readonlyCls}
            />
            <input
              name="updateField2"
              value={formatDateByLang(myFilter.updateField2, i18n.language)}
              readOnly
              className={readonlyCls}
            />
          </div>

          <div className="flex justify-between mt-2">
            <Button onClick={goPrevStep} style={secondaryBtnStyle}>
              {t("Previous Step")}
            </Button>
            <Button onClick={goNextStep} style={primaryBtnStyle}>
              {t("Next Step")}
            </Button>
          </div>
        </div>
      )}

      {/* STEP 3 */}
      {step === 3 &&
        (() => {
          const totals = getTotals();
          const selectedEntries = Object.entries(myFilter.selectedModules || {});
          const hasSelected = selectedEntries.length > 0;

          return (
            <div className="flex flex-col gap-3 text-left text-gray-900 dark:text-gray-100">
              {isCalculating && (
                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                  <Spin size="small" />
                  <span>{t("Calculating price…")}</span>
                </div>
              )}

              {!!calcError && <div className="text-red-600 dark:text-red-400 text-sm">{calcError}</div>}

              <div className="rounded-md border border-gray-200 dark:border-gray-700 overflow-hidden bg-white dark:bg-gray-900">
                <div className="grid grid-cols-12 bg-gray-100 dark:bg-gray-800 text-sm font-semibold">
                  <div className="col-span-7 px-3 py-2 border-r border-gray-200 dark:border-gray-700">{t("Tanım")}</div>
                  <div className="col-span-3 px-3 py-2 border-r border-gray-200 dark:border-gray-700">{t("Referans")}</div>
                  <div className="col-span-2 px-3 py-2 text-right">{t("Son Müşteri Fiyatı")}</div>
                </div>

                <div className="grid grid-cols-12">
                  <div className="col-span-7 px-3 py-2 border-r border-gray-200 dark:border-gray-700">
                    <div className="text-sm font-semibold">
                      BASIC LICENSE{" "}
                      <span className="font-normal text-xs text-gray-600 dark:text-gray-400">
                        ({t("Kullanıcı Sayısı")}: {myFilter.userCount || "-"}, {t("Veritabanı Sayısı")}:{" "}
                        {myFilter.dbCount || "-"})
                      </span>
                    </div>

                    <div className="mt-2 space-y-1">
                      {hasSelected &&
                        selectedEntries.map(([code, m]) => (
                          <div key={code} className="flex gap-1.5">
                            <span className="mt-0.5 h-4 w-4 flex items-center justify-center rounded-full bg-green-600 text-white text-[10px]">
                              ✓
                            </span>
                            <div className="text-sm font-medium">{m?.name || code}</div>
                          </div>
                        ))}

                      <div className="flex gap-1.5 pt-1">
                        <span className="mt-0.5 h-4 w-4 flex items-center justify-center rounded-full bg-green-600 text-white text-[10px]">
                          ✓
                        </span>
                        <div>
                          <div className="text-sm font-medium">{t("Destek ve Güncelleme")}</div>
                          <div className="text-xs text-gray-600 dark:text-gray-400">
                            {formatDateByLang(myFilter.updateField1, i18n.language)} –{" "}
                            {formatDateByLang(myFilter.updateField2, i18n.language)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-span-3 px-3 py-2 border-r border-gray-200 dark:border-gray-700">
                    <div className="space-y-1 text-sm">
                      {hasSelected ? (
                        selectedEntries.map(([code]) => {
                          const row = calcByModule?.[code];
                          return (
                            <div key={code} className="font-medium">
                              {row?.reference || "-"}
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-gray-500">-</div>
                      )}
                    </div>
                  </div>

                  <div className="col-span-2 px-3 py-2 text-right">
                    <div className="space-y-1 text-sm">
                      {hasSelected ? (
                        selectedEntries.map(([code]) => {
                          const row = calcByModule?.[code] || {};
                          return (
                            <div key={code} className="font-semibold">
                              {money(row.licensePrice)} {totals.currency}
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-gray-500">-</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-12 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
                  <div className="col-span-7" />
                  <div className="col-span-5 grid grid-cols-2 text-sm">
                    <div className="px-3 py-1 font-medium">{t("Toplam (Genel)")}</div>
                    <div className="px-3 py-1 text-right font-semibold">
                      {money(totals.totalGeneral)} {totals.currency}
                    </div>

                    <div className="px-3 py-1 font-medium">{t("Bayi İndirim")}</div>
                    <div className="px-3 py-1 text-right">%{Math.round(totals.discountRate * 100)}</div>

                    <div className="px-3 py-1 font-semibold">{t("Toplam (Bayi)")}</div>
                    <div className="px-3 py-1 text-right font-semibold">
                      {money(totals.totalReseller)} {totals.currency}
                    </div>
                  </div>
                </div>
              </div>

              <div className="rounded-md border border-gray-200 dark:border-gray-700 overflow-hidden bg-white dark:bg-gray-900">
                <div className="px-3 py-2 bg-gray-100 dark:bg-gray-800 text-sm font-semibold">
                  {t("Tavsiye Edilen Fiyat ve Hizmetler")}
                </div>

                <div className="grid grid-cols-12">
                  <div className="col-span-10 px-3 py-2 border-r border-gray-200 dark:border-gray-700 text-xs space-y-1">
                    <div>{t("Yazılım")}</div>
                    <div>{t("Destek ve Güncelleme")}</div>
                    <div>{t("Kurulum")}</div>
                    <div>{t("Eğitim")}</div>
                  </div>

                  <div className="col-span-2 px-3 py-2 text-xs text-right space-y-1">
                    <div className="font-semibold">
                      {money(totals.lic)} {totals.currency}
                    </div>
                    <div className="font-semibold">
                      {money(totals.upd)} {totals.currency}
                    </div>
                    <div className="font-semibold">
                      {money(totals.ins)} {totals.currency}
                    </div>
                    <div className="font-semibold">
                      {money(totals.trn)} {totals.currency}
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-12 border-t border-gray-200 dark:border-gray-700">
                  <div className="col-span-10 px-3 py-2 bg-blue-600 text-white font-semibold text-sm">{t("Toplam")}</div>
                  <div className="col-span-2 px-3 py-2 text-right font-semibold text-sm bg-blue-600 text-white">
                    {money(totals.totalGeneral)} {totals.currency}
                  </div>
                </div>
              </div>

              <div className="flex justify-between pt-1">
                <Button onClick={goPrevStep} style={secondaryBtnStyle}>
                  {t("Previous Step")}
                </Button>
                <Button onClick={goNextStep} style={primaryBtnStyle}>
                  {t("Next Step")}
                </Button>
              </div>
            </div>
          );
        })()}

      {/* STEP 4 */}
      {step === 4 && (
        <div className="flex flex-col gap-4 text-left text-gray-900 dark:text-gray-100">
          <div className="flex flex-col md:flex-row items-start gap-3">
            <label className={labelWideCls}>{t("Lisansın Sahibi")}</label>

            <Radio.Group
              value={String(myFilter.customer.ownerType) === "2" ? "personal" : "corporate"}
              onChange={(e) => {
                const v = e.target.value;
                setCustomer({ ownerType: v === "personal" ? 2 : 1 });
              }}
            >
              <Radio value="corporate">{t("Kurumsal")}</Radio>
              <Radio value="personal">{t("Şahıs")}</Radio>
            </Radio.Group>
          </div>

          {!!genError && (
            <div className="text-red-600 dark:text-red-400 text-sm">{genError}</div>
          )}

          {/* CORPORATE */}
          {String(myFilter.customer.ownerType) !== "2" && (
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                {t("Tam ticaret unvanı")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.tradeName}
                  onChange={(e) => setCustomer({ tradeName: e.target.value })}
                />
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("Temsilci Adı")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.representativeName}
                  onChange={(e) => setCustomer({ representativeName: e.target.value })}
                />
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("Temsilci Pozisyonu")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.representativeTitle}
                  onChange={(e) => setCustomer({ representativeTitle: e.target.value })}
                />
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("E-Posta")}
              </div>
              <div className="col-span-8">
                <input
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  className={errors.email ? selectErrCls : inputCls}
                  value={myFilter.customer.email}
                  onChange={(e) => {
                    const v = e.target.value;
                    setCustomer({ email: v });

                    const trimmed = v.trim();
                    if (!trimmed) {
                      setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
                      return;
                    }

                    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
                    setErrors((p) => ({ ...p, email: ok ? "" : t("Geçerli bir e-posta giriniz.") }));
                  }}
                  onBlur={() => {
                    const v = (myFilter.customer.email || "").trim();
                    if (!v) {
                      setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
                      return;
                    }
                    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
                    if (!ok) setErrors((p) => ({ ...p, email: t("Geçerli bir e-posta giriniz.") }));
                  }}
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">* {errors.email}</p>}
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("Ticaret Sicil Numarası")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.tradeRegistryNo}
                  onChange={(e) => setCustomer({ tradeRegistryNo: e.target.value })}
                />
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("Adres")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.address}
                  onChange={(e) => setCustomer({ address: e.target.value })}
                />
              </div>
            </div>
          )}

          {/* PERSONAL */}
          {String(myFilter.customer.ownerType) === "2" && (
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                {t("Ad / Soyad")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.fullName}
                  onChange={(e) => setCustomer({ fullName: e.target.value })}
                />
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("E-Posta")}
              </div>
              <div className="col-span-8">
                <input
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  className={errors.email ? selectErrCls : inputCls}
                  value={myFilter.customer.email}
                  onChange={(e) => {
                    const v = e.target.value;
                    setCustomer({ email: v });

                    const trimmed = v.trim();
                    if (!trimmed) {
                      setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
                      return;
                    }

                    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
                    setErrors((p) => ({ ...p, email: ok ? "" : t("Geçerli bir e-posta giriniz.") }));
                  }}
                  onBlur={() => {
                    const v = (myFilter.customer.email || "").trim();
                    if (!v) {
                      setErrors((p) => ({ ...p, email: t("E-Posta zorunludur.") }));
                      return;
                    }
                    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
                    if (!ok) setErrors((p) => ({ ...p, email: t("Geçerli bir e-posta giriniz.") }));
                  }}
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">* {errors.email}</p>}
              </div>

              <div className="col-span-4 text-right pr-2 pt-2 text-sm">
                <span className="text-red-500">*</span>&nbsp;{t("Adres")}
              </div>
              <div className="col-span-8">
                <input
                  className={inputCls}
                  value={myFilter.customer.address}
                  onChange={(e) => setCustomer({ address: e.target.value })}
                />
              </div>
            </div>
          )}

          {/* Ortak alanlar */}
          <div className="grid grid-cols-12 gap-3">
            <div className="col-span-4 text-right pr-2 pt-2 text-sm">
              <span className="text-red-500">*</span>&nbsp;{t("Ülke")}
            </div>
            <div className="col-span-3">
              <select
                id="country"
                name="country"
                value={myFilter.country || (countryOptions[0]?.value ?? "")}
                onChange={(e) => setMyFilter((p) => ({ ...p, country: e.target.value }))}
                className={selectCls}
              >
                {countryOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-2" />

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">
              <span className="text-red-500">*</span>&nbsp;{t("Language")}
            </div>
            <div className="col-span-3">
              <select
                id="language"
                name="language"
                value={myFilter.language || (languageOptions[0]?.value ?? "")}
                onChange={(e) => setMyFilter((p) => ({ ...p, language: e.target.value }))}
                className={selectCls}
              >
                {languageOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-2" />

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Referansınız")}</div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.customer.reference}
                onChange={(e) => setCustomer({ reference: e.target.value })}
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Grup")}</div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.customer.group}
                onChange={(e) => setCustomer({ group: e.target.value })}
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Not")}</div>
            <div className="col-span-8">
              <textarea
                className={textareaCls}
                value={myFilter.customer.note}
                onChange={(e) => setCustomer({ note: e.target.value })}
              />
            </div>

            {/* API alanları: license.ownerType vb. ise myFilter.customer yerine düzelt */}
            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Owner Type")}</div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.ownerType}
                onChange={(e) => setMyFilter((p) => ({ ...p, ownerType: e.target.value }))}
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Owner RegistryNo")}</div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.ownerRegistryNo}
                onChange={(e) => setMyFilter((p) => ({ ...p, ownerRegistryNo: e.target.value }))}
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Owner Address")}</div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.ownerAddress}
                onChange={(e) => setMyFilter((p) => ({ ...p, ownerAddress: e.target.value }))}
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">
              {t("Owner Representative Position")}
            </div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.ownerRepresentativePosition}
                onChange={(e) =>
                  setMyFilter((p) => ({ ...p, ownerRepresentativePosition: e.target.value }))
                }
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">
              {t("Owner Representative Name")}
            </div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.ownerRepresentativeName}
                onChange={(e) =>
                  setMyFilter((p) => ({ ...p, ownerRepresentativeName: e.target.value }))
                }
              />
            </div>

            <div className="col-span-4 text-right pr-2 pt-2 text-sm">{t("Owner Mail")}</div>
            <div className="col-span-8">
              <input
                className={inputCls}
                value={myFilter.ownerMail}
                onChange={(e) => setMyFilter((p) => ({ ...p, ownerMail: e.target.value }))}
              />
            </div>
          </div>

          <div className="flex items-center gap-3 mt-1">
            <input
              type="checkbox"
              checked={!!myFilter.customer.directApprove}
              onChange={(e) => setCustomer({ directApprove: e.target.checked })}
              className="h-4 w-4"
            />
            <span className="text-red-600">{t("Satışları Direkt Onayla")}</span>
          </div>

          <div className="flex justify-between pt-2">
            <Button onClick={goPrevStep} style={secondaryBtnStyle} disabled={isGenerating}>
              {t("Önceki Adım")}
            </Button>
            <Button onClick={handleCreateLicence} style={primaryBtnStyle} disabled={isGenerating}>
              {isGenerating ? t("Loading") : t("Lisans Oluştur")}
            </Button>
          </div>
        </div>
      )}

    </Modal>
  );
};

export default NewLicence;